import UpsellsItem from "./UpsellsItem";
import { Product } from "@interfaces/dto/products.dto";

type Props = {
  dataUpsellsProducts: Product[];
};

const UpsellsProducts = ({ dataUpsellsProducts }: Props) => {
  return (
    <div className="col-12 col-lg-3 sidebar">
      <h5 className="title rounded-2">สินค้าขายดีแนะนำ</h5>
      <div className="product-list-grid">
        <div className="row">
          {dataUpsellsProducts && (
            <UpsellsItem dataUpsells={dataUpsellsProducts} />
          )}
        </div>
      </div>
    </div>
  );
};

export default UpsellsProducts;
